import { Record } from "immutable";

export type QuizModuleDetailsType = {
  moduleTitle?: string;
};

export const defaultQuizModuleDetails: QuizModuleDetailsType = {
  moduleTitle: undefined
};

export default class QuizModuleDetails extends Record(
  defaultQuizModuleDetails
) {}
